export default "__VITE_ASSET__0da4bb11__"